import { useLoaderData, json, LoaderFunction, MetaFunction } from 'remix';
import { catalogueClient } from '../clients';
import {
  FrontpageDocument,
  FrontpageQuery,
} from '../crystallize/queries/frontpage.generated';
import { normalizeDocumentNode } from '../crystallize/utils/normalizeDocumentNode';
import Grid from '@crystallize/grid-renderer/react';
import { GridItem } from '../components/grid-item';
import { Products } from '../components/products';
import { componentContent } from '../crystallize/utils/componentContent';
import { HttpCacheHeaderTagger } from '~/http-cache-header-tagger';

export let loader: LoaderFunction = async () => {
  const path = '/frontpage';
  const data = await catalogueClient.request<FrontpageQuery>(
    normalizeDocumentNode(FrontpageDocument),
    { path }
  );

  return json(
    { ...data, path },
    HttpCacheHeaderTagger('30s', '1w', ['frontpage'])
  );
};

export let meta: MetaFunction = ({ data }) => {
  let {
    catalogue: { meta },
  } = data;
  let metaData = componentContent(meta.content, 'ContentChunkContent')
    .chunks[0];

  return {
    title: `${componentContent(metaData[0].content, 'SingleLineContent').text}`,
    description: `${
      componentContent(metaData[1].content, 'RichTextContent').plainText[0]
    }`,
    'og:image': `${
      componentContent(metaData[2].content, 'ImageContent')?.images[0]?.url
    }`,
  };
};

export function headers() {
  return HttpCacheHeaderTagger('1m', '1w', ['index']).headers;
}

export default function Index() {
  let { catalogue, donuts } = useLoaderData();
  let { grid } = catalogue;

  const children = ({ cells }) => {
    return cells.map((cell, index) => (
      <div
        style={{
          gridColumn: `span ${cell.layout.colspan}`,
          gridRow: `span ${cell.layout.rowspan}`,
        }}
        id="grid-item"
        key={'cell' + index}
      >
        <GridItem cell={cell} />
      </div>
    ));
  };

  return (
    <div className="py-20">
      <div
        className="bg-background5 z-0 absolute left-0 right-0 bottom-0 rounded-tl-full rounded-tr-full"
        style={{
          top: '45%',
          zIndex: '-1',
        }}
      ></div>
      <div className="container mx-auto flex flex-col items-center py-12 sm:py-24">
        <div className="w-11/12 sm:w-2/3 lg:flex justify-center items-center flex-col  mb-5 sm:mb-10">
          <h1 className="font-extrabold text-5xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-center md:leading-10">
            Доставка цевтов в<span className="text-text"> Геленджике</span>
          </h1>
          <p className="mt-5 sm:mt-10 lg:w-10/12 text-text font-normal text-center text-sm sm:text-lg">
            Принимаем заказы со всего мира 24/7 <br /> За 9 лет работы доставили
            более 110000 улыбок
          </p>
        </div>
        <div className="flex justify-center items-center">
          <button className="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-text bg-text transition duration-150 ease-in-out hover:bg-text lg:text-xl lg:font-bold  rounded text-white px-4 sm:px-10 border border-text py-2 sm:py-4 text-sm">
            Позвонить нам
          </button>
          <button className="ml-4 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-text bg-transparent transition duration-150 ease-in-out hover:border-text lg:text-xl lg:font-bold  hover:text-text rounded border border-text text-text px-4 sm:px-10 py-2 sm:py-4 text-sm">
            Написать WhatsApp
          </button>
        </div>
      </div>
      <Grid model={grid.content.grids[0]} className="gap-5">
        {children}
      </Grid>
      <Products donuts={donuts} />
    </div>
  );
}
